<template>
  <div class="flex flex-col gap-4 items-center text-center">
    <LoaderAnimation/>
    <p>Loading server...<br/>On inactive, this can take a while.</p>
  </div>
</template>

<script>
  import LoaderAnimation from "@/components/LoaderAnimation.vue";

  export default {
    name: "ConnectScreen",
    components: {
      LoaderAnimation
    },
  }
</script>